<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد وضعیت فعلی ناوگان در خطوط </span>

    </div>

</div>

<div class="d-flex justify-content-around flex-wrap mt-4" style="direction: rtl;">

    <!-- وضعیت ناوگان -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="py-4">

            <p class="text-center f18"> وضعیت ناوگان </p>

            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <!-- ناوگان غایب  -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="py-4">

            <p class="text-center f18"> ناوگان غایب </p>

            <div style="height: 380px !important;">

                <div class="mt-3 p-2">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

                    <div class="section border border-2 mt-2" style="max-height: 320px;overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center"> عملیات </th>

                                    <th class="text-center"> کد خط </th>

                                    <th class="text-center"> نام خط </th>

                                    <th class="text-center"> نام و نام خانوادگی </th>

                                    <th class="text-center"> پلاک </th>

                                    <th class="text-center"> موبایل </th>

                                    <th class="text-center"> نوع خودرو </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lst_Deactive;let i = index">

                                    <td> {{ i + 1 | faNum }}</td>

                                    <td class=""> 

                                        <i class="fa fa-info-circle fa-lg pointer" (click)="openDetails(item)"></i>
                                        
                                    </td>

                                    <td> {{ item.strBusLineCode | faNum }}</td>

                                    <td> {{ item.strBusLineName | faNum }}</td>

                                    <td> {{ item.strFullName | faNum }}</td>

                                    <td> {{ item.strVehicleNo | faNum }}</td>

                                    <td> {{ item.strMobile | faNum }}</td>

                                    <td> {{ item.strGPSType_strComment | faNum }}</td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- ناوگان در مرخصی   -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="py-4">

            <p class="text-center f18"> ناوگان در مرخصی  </p>

            <div style="height: 380px !important;">

                <div class="mt-3 p-2">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list2($event.target)">

                    <div class="section border border-2 mt-2" style="max-height: 320px;overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center"> عملیات </th>

                                    <th class="text-center"> کد خط </th>

                                    <th class="text-center"> نام خط </th>

                                    <th class="text-center"> نام و نام خانوادگی </th>

                                    <th class="text-center"> پلاک </th>

                                    <th class="text-center"> موبایل </th>

                                    <th class="text-center"> نوع خودرو </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lst_Vacation;let i = index">

                                    <td> {{ i + 1 | faNum }}</td>

                                    <td class=""> 

                                        <i class="fa fa-info-circle fa-lg pointer" (click)="openDetails(item)"></i>
                                        
                                    </td>

                                    <td> {{ item.strBusLineCode | faNum }}</td>

                                    <td> {{ item.strBusLineName | faNum }}</td>

                                    <td> {{ item.strFullName | faNum }}</td>

                                    <td> {{ item.strVehicleNo | faNum }}</td>

                                    <td> {{ item.strMobile | faNum }}</td>

                                    <td> {{ item.strGPSType_strComment | faNum }}</td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- ناوگان فعال -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="d-flex justify-content-center flex-wrap">

            <div class="col-12 mt-3">

                <h3 class="text-center"> ناوگان فعال </h3>

            </div>

            <div class="col-10 border rounded-3 border-2 border-secondary mb-5 p-2 mt-2">

                <input type="text" class="w-100 form-control my-2" placeholder="جستجو کنید ..." (keyup)="filter_list3($event.target)">

                <div id="activeFleetMap" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- ناوگان غایب  -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="d-flex justify-content-center flex-wrap">

            <div class="col-12 mt-3">

                <h3 class="text-center"> ناوگان غایب  </h3>

            </div>

            <div class="col-10 border rounded-3 border-2 border-secondary mb-5 p-2 mt-2">

                <input type="text" class="w-100 form-control my-2" placeholder="جستجو کنید ..." (keyup)="filter_list4($event.target)">

                <div id="absenceFleetMap" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- ناوگان در مرخصی  -->

    <div class="col-md-11 col-12 rounded shadow mb-5">

        <div class="d-flex justify-content-center flex-wrap">

            <div class="col-12 mt-3">

                <h3 class="text-center"> ناوگان در مرخصی  </h3>

            </div>

            <div class="col-10 border rounded-3 border-2 border-secondary mb-5 p-2 mt-2">

                <input type="text" class="w-100 form-control my-2" placeholder="جستجو کنید ..." (keyup)="filter_list5($event.target)">

                <div id="vacationFleetMap" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>


</div>